module.exports = __webpack_public_path__ + "static/media/bg-profile.682b0310.png";